'use strict';/* global define:false, console:false */define('modules/objectives/states/team_objectives_user_archive/controller',[],function(){'use strict';// @ngInject
controller.$inject = ["$scope", "$state", "Objective", "ObjectiveUtils", "user"];
function controller($scope,$state,Objective,ObjectiveUtils,user){// jshint validthis:true
// jshint latedef:false
var ctrl=this;ctrl.user=user;ctrl.filter=$state.params.filter||'';}return controller;});
